module.exports = __webpack_public_path__ + "static/rad2-366486888cb19bd74f7d115078e05080.jpg";